<div class="profile__actions">
  <ng-container *hasWorkspaceFeature="[WorkspaceFeatures.showSettingsButton]">
    @if (permissionService.checkPermissions([EUserPermissions.settings])) {
    <button (click)="goSettings()" matTooltip="{{ 'Settings' }}" mat-icon-button color="primary" class="profile__action-fab">
      <mat-icon class="profile__action-fab-icon" svgIcon="settings"></mat-icon>
    </button>
    }
  </ng-container>
  <button
    *hasWorkspaceFeature="[WorkspaceFeatures.canTryCreateChannelByPhone]"
    mat-icon-button
    color="primary"
    (click)="createPhoneChannel()"
    class="profile__action-fab">
    <mat-icon class="profile__action-fab-icon" svgIcon="chat"></mat-icon>
  </button>
  <button
    [matMenuTriggerFor]="menuProfile"
    *hasWorkspaceFeature="[WorkspaceFeatures.canCreateConversation, WorkspaceFeatures.canCreateGrupalConversations]"
    mat-icon-button
    color="primary"
    class="profile__action-fab">
    <mat-icon class="profile__action-fab-icon" svgIcon="chat"></mat-icon>
  </button>
  <mat-menu #menuProfile>
    @if (!isMasterStore()) {
    <button *hasWorkspaceFeature="[WorkspaceFeatures.canCreateConversation]" mat-menu-item (click)="openNewDirectChat()">
      {{ 'NGX-MESSAGING.directMessage' | translate }}
    </button>
    }
    <button
      *hasWorkspaceFeature="[WorkspaceFeatures.canCreateGrupalConversations]"
      mat-menu-item
      (click)="openNewGroupChat()">
      {{ alternateTranslationService.alternate('groupChannel') | translate }}
    </button>
    @if (permissionService.checkPermissions([EUserPermissions.createBroadcast, EUserPermissions.createGroupBroadcast])) {
    <button *hasWorkspaceFeature="[WorkspaceFeatures.canCreateBroadcastChannel]" mat-menu-item (click)="openNewBroadcast()">
      {{ 'NGX-MESSAGING.broadcastChannel' | translate }}
    </button>
    }
  </mat-menu>
</div>
